import React, { useState } from 'react';
import { Col, Row } from '../../../lib/utils';
import { Body3Bold, CaptionRegular } from '../../../lib/font';
import { colors } from '../../../lib/colors';
import ProfileImage from '../../ProfileImage';
import dayjs from 'dayjs';
import { RegularText } from '@/lib/Text';
import SvgIcon from '@/components/SvgIcon';

type Receiver = {
    receiverId?: string;
    receiverName?: string;
    profileImageUrl?: string;
    profileName?: string;
    profileColorType?: string;
};

const FeedProfileItem = ({ item, postType, role }: any) => {
    const [showParticipants, setShowParticipants] = useState(false);

    const receivers: Receiver[] = Array.isArray(item?.receivers) ? item.receivers : [];
    const firstReceiverName = receivers[0]?.receiverName ?? '회원';
    const extraCount = Math.max(0, receivers.length - 1);

    return (
        <>
            <Row style={{ width: 722, alignSelf: 'center', justifyContent: 'space-between', marginTop: 20 }}>
                <Row style={{ alignItems: 'center' }}>
                    <ProfileImage
                        imageUrl={item?.profileImageUrl}
                        type="Middle"
                        profileName={item?.profileName}
                        profileColorType={item?.profileColorType}
                        right={8}
                    />
                    <Col>
                        <Row style={{ alignItems: 'center' }}>
                            <Body3Bold style={{ color: colors.LAVEL_3 }}>{`${item?.writerName}  ${
                                role === 'coach' ? '강사' : '회원'
                            }`}</Body3Bold>

                            {role === 'coach' && (
                                <Row style={{ alignItems: 'center' }}>
                                    <SvgIcon
                                        name="SvgRightStrokeArrow"
                                        size={14}
                                        fill={colors.trans}
                                        stroke={colors.Text_1}
                                        className="mx-[9px]"
                                        strokeWidth={1.5}
                                    />
                                    {item?.postType === 'FIXED' ? (
                                        <Body3Bold style={{ color: colors.POINT_1 }}>공지글</Body3Bold>
                                    ) : postType === 'SCHEDULEREPORT' ? (
                                        <Body3Bold style={{ color: colors.POINT_1 }}>
                                            {`${firstReceiverName} 회원 수업일지`}
                                        </Body3Bold>
                                    ) : extraCount > 0 ? (
                                        // 그룹/다수 회원 — 클릭 시 참여자 모달
                                        <Body3Bold
                                            style={{
                                                color: colors.POINT_1,
                                                cursor: 'pointer',
                                                textDecoration: 'underline',
                                                textDecorationStyle: 'dotted',
                                                textUnderlineOffset: '3px',
                                            }}
                                            onClick={() => setShowParticipants(true)}
                                        >
                                            {`${firstReceiverName} 회원 외 ${extraCount}명`}
                                        </Body3Bold>
                                    ) : (
                                        <Body3Bold style={{ color: colors.POINT_1 }}>
                                            {`${firstReceiverName} 회원`}
                                        </Body3Bold>
                                    )}
                                </Row>
                            )}
                        </Row>
                        <Row className="flex items-center">
                            <RegularText fontSize={14} lineHeight={19} color={'#8F97A7'} className="mr-[12px]">
                                {dayjs(item?.createdTime).format('M월 D일 HH:mm')}
                            </RegularText>
                            {role !== 'coach' && (
                                <CaptionRegular style={{ color: '#8F97A7' }}>
                                    {`${firstReceiverName} 강사 담당`}
                                </CaptionRegular>
                            )}
                        </Row>
                    </Col>
                </Row>
            </Row>

            {/* 참여 회원 목록 모달 */}
            {showParticipants && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1100,
                    }}
                    onClick={() => setShowParticipants(false)}
                >
                    <Col
                        style={{
                            width: 420,
                            maxHeight: '75vh',
                            backgroundColor: '#fff',
                            borderRadius: 14,
                            padding: 24,
                            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
                        }}
                        onClick={(e: React.MouseEvent) => e.stopPropagation()}
                    >
                        <Row style={{ alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                            <span style={{ fontSize: 18, fontWeight: 700, color: '#111827' }}>
                                참여 회원 ({receivers.length}명)
                            </span>
                            <button
                                onClick={() => setShowParticipants(false)}
                                style={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: 6,
                                    border: 'none',
                                    backgroundColor: '#F3F4F6',
                                    color: '#6B7280',
                                    cursor: 'pointer',
                                    fontSize: 14,
                                }}
                            >
                                ✕
                            </button>
                        </Row>

                        <Col style={{ gap: 8, overflowY: 'auto' }}>
                            {receivers.map((r, idx) => (
                                <Row
                                    key={r.receiverId ?? idx}
                                    style={{
                                        alignItems: 'center',
                                        padding: '10px 12px',
                                        borderRadius: 10,
                                        backgroundColor: '#F9FAFB',
                                        border: '1px solid #F1F5F9',
                                        gap: 10,
                                    }}
                                >
                                    <ProfileImage
                                        imageUrl={r.profileImageUrl}
                                        type="Small"
                                        profileName={r.profileName || r.receiverName}
                                        profileColorType={r.profileColorType}
                                    />
                                    <span style={{ fontSize: 14, fontWeight: 600, color: '#1F2937' }}>
                                        {r.receiverName || '-'}
                                    </span>
                                </Row>
                            ))}
                        </Col>
                    </Col>
                </div>
            )}
        </>
    );
};

export default FeedProfileItem;
